import axios from 'axios';

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-type': 'application/json',
  },
});

apiClient.interceptors.request.use(config => {
  if (apiClient.defaults.headers.common.Authorization !== axios.defaults.headers.common.Authorization) {
    apiClient.defaults.headers.common.Authorization = axios.defaults.headers.common.Authorization;
  }
  // eslint-disable-next-line no-param-reassign
  config.headers.Authorization = axios.defaults.headers.common.Authorization;
  return config;
}, error => Promise.reject(error));

export default {
  enableTwoFactor() {
    const result = new Promise((resolve, reject) => {
      apiClient.post('/2fa/enable-two-factor-auth')
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
    return result;
  },
  getQrCode() {
    const result = new Promise((resolve, reject) => {
      apiClient.get('/2fa/get-qr-code')
        .then(response => resolve(response))
        .catch(error => reject(error));
    });

    return result;
  },
  disableTwoFactor(body) {
    const result = new Promise((resolve, reject) => {
      apiClient.delete('/2fa/disable-two-factor-auth', {
        data: body,
      })
        .then(response => resolve(response))
        .catch(error => reject(error));
    });

    return result;
  },
  confirmTwoFactor(body) {
    const result = new Promise((resolve, reject) => {
      apiClient.post('/2fa/confirm-two-factor-auth', body)
        .then(response => resolve(response))
        .catch(error => reject(error));
    });

    return result;
  },
  challenge(payload) {
    return apiClient.post('/2fa/challenge-two-factor-auth', payload);
  },
  confirmSetup(payload) {
    return apiClient.post('/2fa/setup/confirm', payload);
  },
};
